
<fd-flexible-column-layout [(layout)]="localLayout" (layoutChange)="onLayoutChange()">
    <ng-template #startColumn>
        <div class="table-scroll main-table">
            <div class="advanced-search-container" *ngIf="!!advancedSearchOpen">
                <app-advanced-search
                        [currentOrg]="organizationName"
                        [currentPath]="currentPath"
                        [fullPath]="fullPath"
                        [availableResourceTypes]="availableResourceTypes"
                        [resultCount]="items.length"
                        [loadSavedFilters]="advancedSearchTerms"
                        [currentViewName]="currentFilterViewName"
                        [isFclOpen]="this.localLayout === 'OneColumnStartFullScreen'"
                        (close)="advancedSearchToggled.emit(false)"
                        (clearContent)="onClearContent()"
                        (cancelSearch)="onCancelSearch()"
                        (viewSaved)="viewSaved.emit($event)"
                        (applyFilters)="onApplyAdvancedFilters($event)"
                        (filtersModified)="filtersChanged.emit()">
                </app-advanced-search>
            </div>
            <app-data-table #dataTable
                            class="resource-table"
                            [tableKey]="currentTableKey"
                            [persistSort]="true"
                            [persistFilters]="true"
                            [persistSortAdditionalData]="fullPath"
                            [persistFiltersAdditionalData]="fullPath"
                            [loading]="loading"
                            (rowClick)="selectRow($event, false)"
                            [clickable]="true"
                            [displayedColumns]="displayedColumns"
                            [selectedRow]="selectedRow"
                            [dataset]="items"
                            [stickyHeaders]="true"
                            [filterPipe]="filterPipe"
                            [filterPipeArgs]="[searchTerm]"
                            [fixedSortingBy]="'type'"
                            [virtualScrollingEnabled]="true"
                            noDataFilteredMessage="{{noDataFilteredMessage}}"
                            sortProperty="displayName">
                <ng-template #noDataMessageTemplate>
                    <div [innerHTML]="getNoDataMessage()"></div>
                </ng-template>
                <app-column width="500px" [isSortable]="true" [isFilterable]="true" value="displayName"
                            header="Resource">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <div class="link-wrapper">
                            <div class="link-title-wrapper">
                                <button fd-button
                                        fdType="transparent"
                                        class="margin-right-sm custom-icon"
                                        [title]="row.type"
                                        [routerLink]="getNavigationRoute(row)"
                                        [queryParams]="getNavigationQueryParams(row)">
                                    <app-icon [icon]="row.type | resourceGlyph" size="lg"></app-icon>
                                </button>
                                <a fd-link aria-label="Standard" (click)="selectResource($event)"
                                   class="resource-title"
                                   *ngIf="getNavigationRoute(row)"
                                   [title]="'Display Name: ' + row.displayName"
                                   [routerLink]="getNavigationRoute(row)"
                                   [queryParams]="getNavigationQueryParams(row)"
                                   queryParamsHandling="merge">{{row.displayName}}</a>
                                <span *ngIf="!getNavigationRoute(row)" class="resource-title"
                                      [title]="'Name: ' + row.name">{{ row.displayName }}</span>
                                <div *ngIf="row.markedForDeletion" class="status-wrapper pending-deletion">
                                    <em>{{PENDING_DELETION}}</em>
                                </div>
                                <div class="status-wrapper">
                                    <app-status *ngIf="row.moveInProcess && !containerIsMoving"
                                                (click)="getMoveStatus($event, row)"
                                                [status]="ResourceState.IN_PROCESS"
                                                [withConditionsTable]="false"
                                                i18n-customTooltip="XTOL|Tooltip of the status icon@@tableStatusIconTooltip"
                                                [customTooltip]="RESOURCE_MOVING_IN_PROCESS">
                                    </app-status>
                                </div>
                            </div>
                            <div class="buttons-wrapper" (click)="$event.stopPropagation()">
                                <div [ngClass]="{'buttons-container': true, 'show-buttons': this.showButtons(row)}">
                                    <ng-container>
                                        <button fd-button id='refresh-main-actions-btn' class="custom-icon" (click)="onReloadResource(row)"
                                                [fdCompact]="true" [fdType]="'transparent'" title="Refresh"
                                                i18n-title="XTOL|Tooltip of the Refresh button@@tableRefreshButtonTooltip">
                                        <app-icon icon="rotate-right" size="lg"></app-icon>
                                        </button>
                                        <button fd-button id='edit-main-actions-btn' class="custom-icon"
                                                *ngIf="isEditable(row)"
                                                (click)="onEditResource(row)"
                                                [fdCompact]="true" [fdType]="'transparent'"
                                                [title]="showResourceTitleText(row)"
                                                i18n-title="XTOL|Tooltip of the Edit button@@tableExportButtonTooltip">
                                            <app-icon *ngIf="showEditWithYaml(row); else editWithForm" [icon]="[$any('workspace'), $any('editYaml')]" size="lg" [fixedWidth]="true"></app-icon>
                                            <ng-template #editWithForm>
                                                <app-icon icon="pen" size="lg"></app-icon>
                                            </ng-template>

                                        </button>
                                        <app-organization-actions id="actions-menu"
                                                                  [busy]="policiesLoading"
                                                                  [resource]="row"
                                                                  [advancedSearchOpen]="advancedSearchOpen"
                                                                  (openDetails)="openDetails(row)"
                                                                  (openPolicies)="openPolicies(row)"
                                                                  (openReferences)="openReferences(row)"
                                                                  (openEvents)="openEvents(row)"
                                                                  (openRTDResources)="openRTDResources(row)"
                                                                  [isFclClosed]="isFclClosed()"
                                                                  (isOpen)="setIsActionSheetOpen($event)"
                                                                  (import)="onImport($event)"
                                                                  (delete)="onDeleteResource($event)"
                                                                  (editOrganization)="onEditResource($event)"
                                                                  (editWithForm)="onEditWithForm($event)"
                                                                  (reconcileResource)="onReconcileResource($event)"
                                                                  (reloadResource)="onReloadResource($event)"
                                                                  (editWithYAML)="onEditResource($event)"
                                                                  (moveResource)="onMoveResource($event)"
                                                                  (analyzeFailure)="onAnalyzeFailure($event)"
                                        ></app-organization-actions>
                                        <button fd-button (click)="toggleFcl(row)"
                                                class="toggle-row custom-icon"
                                                [fdCompact]="true" [fdType]="'transparent'"
                                                [title]="isFclClosed() ? 'View Details' : 'Hide Details'">
                                            <app-icon icon="angle-right" size="lg"></app-icon>
                                        </button>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </app-column>
                <app-column [isSortable]="true" width="300px" [isFilterable]="true" value="type" header="Type">
                  <ng-template #tableBodyTemplate let-row='row'>
                    <span>{{row.type}}</span>
                  </ng-template>
                </app-column>
                <app-column [isSortable]="true" [isFilterable]="true" value="description" width="250px"
                            header="Description"></app-column>
                <app-column [isSortable]="true" value="status" header="Ready">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <div class="status-wrapper">
                            <app-status
                                [status]="row.state"
                                [withConditionsTable]="false"
                                [analyzable]="true"
                                [resource]="row"
                                (analyzeFailure)="onAnalyzeFailure($event)"></app-status>
                        </div>
                    </ng-template>
                </app-column>
                <app-column value="labels" header="Labels">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <div *ngIf="row.labels && (row.labels | keyvalue).length > 0">
                            <app-labels-popover [labels]="row.labels" title="Labels"
                                                [labelTextMapping]="labelTextMapping"
                                                [NO_VALUE_LABEL]="NO_VALUE_LABEL"></app-labels-popover>
                        </div>
                    </ng-template>
                </app-column>
                <app-column header="Annotations">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <div *ngIf="row.annotations && (row.annotations | keyvalue).length > 0">
                            <app-labels-popover [labels]="row.annotations" title="Annotations"
                                                [labelTextMapping]="annotationTextMapping"
                                                [NO_VALUE_LABEL]="NO_VALUE_LABEL"></app-labels-popover>
                        </div>
                    </ng-template>
                </app-column>
                <app-column [isSortable]="true" value="modificationTime" header="Modified On">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <app-date [date]="row.modificationTime"></app-date>
                    </ng-template>
                </app-column>
                <app-column [isSortable]="true" value="creationTime" header="Created On">
                    <ng-template #tableBodyTemplate let-row='row'>
                        <app-date [date]="row.creationTime"></app-date>
                    </ng-template>
                </app-column>
                <app-column [isSortable]="true" [isFilterable]="true" value="apiVersion"
                            header="API Version"></app-column>
                <app-column [isSortable]="true" [isFilterable]="true" value="displayName"
                            header="Display Name"></app-column>
                <app-column [isSortable]="true" [isFilterable]="true" value="path" header="Path"></app-column>
                <app-column [isSortable]="true" value="name" header="Name" title="Name"></app-column>
            </app-data-table>
        </div>
        <input type="file" #file hidden (change)="handleFileInputChange()"/>
    </ng-template>
    <ng-template #midColumn>
        <app-content-details #contentDetailsComponent (onEditResource)="onEditResource(selectedRow,undefined ,$event)" (reloadResource)="onReloadResource(selectedRow)" (doCloseFcl)="closeFcl()"
                             [localLayout]="localLayout" [resource]="selectedRow" (editWithForm)="onEditWithForm($event)" (delete)="onDeleteResource($event)" (editOrganization)="onEditResource($event)" [policiesLoading]="policiesLoading"
                             (onUpdateRTDResource)="doUpdateResource(selectedRow)"
                             (onReconcileResource)="onReconcileResource($event)"
        ></app-content-details>
    </ng-template>
</fd-flexible-column-layout>

